export enum VendorTypeFilter {
  All,
  MyDealers,
  Preferred,
}
